import * as API from '@/services/api'

export async function fetchInstance(interactionInstanceToken) {
    const response = await API.get(`/api/qi/${interactionInstanceToken}`)
    return response.data
}

export async function fetchSubInstances(interactionInstanceToken, itemId) {
    const response = await API.get(`/api/qi/${interactionInstanceToken}/i/${itemId}/sub`)
    return response.data
}

export async function startSubInstance(interactionInstanceToken, itemId, name) {
    const response = await API.post(`/api/si/${interactionInstanceToken}/${itemId}?name=${name}`)
    return response.data
}

export async function fetchInstanceItems(interactionInstanceToken) {
    try {
        const response = await API.get(`/api/instance/${interactionInstanceToken}/items`)
        return response.data
    } catch(e) {
        throw e.response.data
    }
}

export async function openItem(interactionInstanceToken, payload) {
    const response = await API.post(`/api/instance/${interactionInstanceToken}/item/${payload.itemId}/open`, payload)
    return response
}

export async function answerItem(interactionInstanceToken, itemId, payload) {
    const response = await API.post(`/api/instance/${interactionInstanceToken}/item/${itemId}`, payload)
    return response
}

export async function postponeItem(interactionInstanceToken, itemId) {
    // refactor post request?
    const response = await API.post(`/api/qi/${interactionInstanceToken}/p/${itemId}`)
    return response
}

export async function fetchItemMetaData(interactionInstanceToken, itemId) {
    const response = await API.get(`/api/qi/${interactionInstanceToken}/i/${itemId}/data`)
    return response.data
}

export async function fetchOutcomeTaskData(interactionInstanceToken, itemId) {
    const response = await API.get(`/api/qi/${interactionInstanceToken}/os/${itemId}`)
    return response.data
}

export async function startOutcomeTask(interactionInstanceToken, itemId) {
    const response = await API.post(`/api/qi/${interactionInstanceToken}/os/${itemId}`)
    return response.data
}

export async function answerOutcomeTaskScenario(interactionInstanceToken, itemId, answer) {
    const response = await API.post(`/api/qi/${interactionInstanceToken}/or/${itemId}/${itemId}/${answer}`)
    return response.data
}

export async function addInteractionInstanceData(interactionInstanceToken, data) {
    const response = await API.post(`/api/instance/${interactionInstanceToken}/data`, data)
    return response.data
}

export async function fetchInteractionInstanceData(interactionInstanceId) {
    const response = await API.get(`/api/instance/${interactionInstanceId}/data`)
    return response.data
}

export async function fetchFountainMap(externalUserToken) {
    const response = await API.get(`/api/fountain/map/${externalUserToken}`)
    return response.data
}

export async function fetchInteractionPrivacyPolicy(interactionInstanceToken) {
    const response = await API.get(`/api/qi/${interactionInstanceToken}/pp`)
    return response.data
}